/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Membersinvitetitle2Inputs */

const en_membersinvitetitle2 = /** @type {(inputs: Membersinvitetitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invite link`)
};

const de_membersinvitetitle2 = /** @type {(inputs: Membersinvitetitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Einladungslink`)
};

/**
* | output |
* | --- |
* | "Invite link" |
*
* @param {Membersinvitetitle2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const membersinvitetitle2 = /** @type {((inputs?: Membersinvitetitle2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Membersinvitetitle2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_membersinvitetitle2(inputs)
	return de_membersinvitetitle2(inputs)
});
export { membersinvitetitle2 as "membersInviteTitle" }